import { combineClasses } from "@/lib/utils";
import styles from "./StatusBadge.module.scss";

export type StatusTone = "success" | "warning" | "danger" | "neutral" | "brand";

export interface StatusBadgeProps {
  label: string;
  tone?: StatusTone |undefined;
  className?: string | undefined;
}

// Purely presentational — a dot + pill in one of 4 tones. What status
// string maps to which tone differs per table (e.g. Members' "APPROVED"
// vs. a future Events page's "UPCOMING"), so that mapping is the caller's
// job, not this component's.
const StatusBadge = ({ label, tone = "neutral", className }: StatusBadgeProps) => (
  <span className={combineClasses(styles.statusPill, styles[tone], className)}>{label}</span>
);

export default StatusBadge;
